module.exports = __webpack_public_path__ + "static/media/building_7.64c9fddb.jpg";